import React from 'react'
import { Button, Icon } from './styles'

interface IPublishButtonProps {
    label: string
    status: 'published' | 'unpublished'
    disabled: boolean
    loading: boolean
    onClick: () => void
}
const IPublishButton = ({ label, disabled, status, loading, onClick }: IPublishButtonProps): JSX.Element => {
    return (
        <Button disabled={disabled} status={status} onClick={onClick}>
            <span style={{ paddingRight: '4.5px' }}>
                <Icon
                    className={
                        loading
                            ? 'fas fa-spinner fa-pulse'
                            : status === 'unpublished'
                            ? 'far fa-share-square'
                            : 'far fa-check-circle'
                    }
                />
            </span>
            {label}
        </Button>
    )
}

export default IPublishButton
